import React from 'react';

const SingleProductContext = React.createContext();
export const SingleProductProvider = SingleProductContext.Provider;
export default SingleProductContext